<template>
  <div class="mit-home-page mit-page">
      <v-container>
      <v-row>
        <v-col cols="12" class="d-flex justify-left">
          <div class="pa-2">
            <h3 class="pb-2">TIG User Access</h3>
            <p>This is the place to manage tig apps user access. You must be an admin to make changes.</p>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>

  export default {
    name: 'MitHomePage',
    components: {
    },
    data: function() {
      return {
      }
    },
    mounted() {
    },
    methods: {
      // exampleFunction: function(model) {
      //   console.log(model);
      // }
    }
  }
</script>

<style lang="scss" scoped>

</style>
